/**
 * Format event date and time with smart formatting
 * - "today at 4:00pm"
 * - "this monday at 3:00pm"
 * - "february 23rd, Saturday at 3PM"
 */
export const formatEventDateTime = (date) => {
  if (!date) return '';
  
  const eventDate = new Date(date);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const eventDay = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
  
  // Calculate days difference
  const daysDiff = Math.floor((eventDay - today) / (1000 * 60 * 60 * 24));
  
  // Format time
  const time = eventDate.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).toLowerCase().replace(/\s/g, '');
  
  // Today
  if (daysDiff === 0) {
    return `today at ${time}`;
  }
  
  // This week (next 7 days)
  if (daysDiff > 0 && daysDiff <= 7) {
    const dayName = eventDate.toLocaleDateString('en-US', { weekday: 'long' });
    return `this ${dayName.toLowerCase()} at ${time}`;
  }
  
  // More than a week out - full date
  const month = eventDate.toLocaleDateString('en-US', { month: 'long' });
  const day = eventDate.getDate();
  const dayName = eventDate.toLocaleDateString('en-US', { weekday: 'long' });
  const ordinal = getOrdinal(day);
  
  return `${month} ${day}${ordinal}, ${dayName} at ${time.toUpperCase()}`;
};

/**
 * Get ordinal suffix for day (1st, 2nd, 3rd, 4th, etc.)
 */
const getOrdinal = (day) => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};


